import { _createModule } from "@/factories/module/create";

export const moduleFactory = {
  create: _createModule,
} as const;
